

export const debounce = (callback: (...args: any) => any, duration = 500) => {
    let timer: NodeJS.Timeout;
    return (...args: any) => {
        clearTimeout(timer);
        timer = setTimeout(() => { callback.apply(this, args)}, duration)
    }
}